import loadImage from './loadImage';
import preloadImages from './preloadImages';
export default {
  loadImage: loadImage,
  preloadImages: preloadImages
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/swiper/esm/components/core/images/index.js
// module id = null
// module chunks = 